import { render, staticRenderFns } from "./password-management.vue?vue&type=template&id=f39a2962&"
import script from "./password-management.vue?vue&type=script&lang=js&"
export * from "./password-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports